export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center relative z-10">
        <h2 className="font-heading text-4xl md:text-6xl text-foreground-950 font-semibold mb-4">
          Начни покупать с YOYBUY
        </h2>
        <p className="text-foreground-500 text-base md:text-lg max-w-xl mx-auto mb-10">
          Присоединяйтесь к тысячам пользователей, которые уже используют YOYBUY Spreadsheet для удобного и выгодного онлайн-шопинга.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-10 py-5 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Перейти к YOYBUY Spreadsheet
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>

      <div className="mt-16 flex justify-center gap-6 md:gap-10 px-6 overflow-hidden">
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20on%20cream%20background%2C%20clean%20fashion%20item%20isolated%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20simple%20composition%2C%20Scandinavian%20aesthetic&width=400&height=400&seq=cta-product-01&orientation=squarish"
            alt="YOYBUY товар 1"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20with%20beige%20cream%20background%2C%20simple%20fashion%20accessory%20displayed%20minimally%2C%20soft%20warm%20lighting%2C%20editorial%20quality%2C%20neutral%20aesthetic%2C%20no%20distractions%2C%20elegant%20composition&width=400&height=400&seq=cta-product-02&orientation=squarish"
            alt="YOYBUY товар 2"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20neutral%20minimalist%20product%20shot%20on%20light%20background%2C%20fashion%20item%20with%20gentle%20shadows%2C%20soft%20daylight%2C%20clean%20aesthetic%2C%20professional%20product%20display%2C%20cream%20tones%2C%20Scandinavian%20style&width=400&height=400&seq=cta-product-03&orientation=squarish"
            alt="YOYBUY товар 3"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Simple%20elegant%20fashion%20product%20photography%20with%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20editorial%20style%2C%20neutral%20earth%20tones%2C%20clean%20and%20peaceful%20aesthetic&width=400&height=400&seq=cta-product-04&orientation=squarish"
            alt="YOYBUY товар 4"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20product%20display%20on%20cream%20surface%20with%20soft%20natural%20window%20light%2C%20fashion%20item%20photographed%20cleanly%2C%20warm%20ambient%20tone%2C%20editorial%20product%20photography%2C%20neutral%20aesthetic%2C%20organic%20texture&width=400&height=400&seq=cta-product-05&orientation=squarish"
            alt="YOYBUY товар 5"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20beige%20cream%20background%2C%20simple%20fashion%20piece%20with%20gentle%20shadows%2C%20warm%20soft%20lighting%2C%20editorial%20quality%2C%20minimalist%20Scandinavian%20style%2C%20neutral%20tones%2C%20elegant%20display&width=400&height=400&seq=cta-product-06&orientation=squarish"
            alt="YOYBUY товар 6"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}